import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useEdit } from "../../lib/cms";
import { SchemaForm, SidePanel } from "./SchemaForm";
import { EditBar } from "./EditBar";

export function EntityEditor({ kind, id, schema, title, onLive, onPublished }) {
  const { editing, preview } = useEdit();
  const [v, setV] = useState(null);
  const [hasDraft, setHasDraft] = useState(false);
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const base = `/cms/entity/${kind}/${id}`;
  const load = () => api.get(base).then((r) => { setV(r.data.draft); setHasDraft(r.data.has_draft); setDirty(false); onLive(r.data.has_draft ? r.data.draft : null); }).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (editing) load(); else { setV(null); setOpen(false); onLive(null); } }, [editing, id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!editing || !v) return <EditBar />;
  const change = (x) => { setV(x); setDirty(true); onLive(x); };
  const run = async (fn, msg, after) => { setBusy(true); try { await fn(); toast.success(msg); await after(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const save = () => run(() => api.put(base, v), "Draft saved — visitors still see the published page", load);
  const publish = () => run(async () => { if (dirty) await api.put(base, v); await api.post(`${base}/publish`); }, "Published — your changes are live", async () => { await load(); onPublished(); });
  const discard = () => window.confirm("Throw away draft changes to this page?") && run(() => api.post(`${base}/discard`), "Draft discarded", async () => { await load(); onPublished(); });
  return (
    <>
      {open && !preview && <SidePanel title={title} onClose={() => setOpen(false)} footer={<button className="btn-primary w-full" onClick={() => setOpen(false)} data-testid="cms-panel-done">Done</button>}>
        <SchemaForm fields={schema} value={v} onChange={change} />
        <p className="text-xs text-slate-500">Changes show on the page straight away. Save draft or Publish from the bar at the bottom.</p>
      </SidePanel>}
      <EditBar dirty={dirty} busy={busy} hasDraft={hasDraft} onSave={save} onPublish={publish} onDiscard={discard} onContent={() => setOpen(true)} />
    </>
  );
}
